var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 774.871,
    height: 80.959,
    viewBox: "0 0 774.871 80.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6473",
    "data-name": "Rectangle 6473",
    width: 774.871,
    height: 80.959,
    transform: "translate(0 0.001)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86309",
    "data-name": "Path 86309",
    d: "M722.732,41.137a11.351,11.351,0,0,1,22.63-1.285,11.386,11.386,0,0,1-11.353,12.664h-.051a11.31,11.31,0,0,1-11.226-11.38m10.133-24.783c.013.43,0,.86,0,1.29,0,3.1-.005,6.192.005,9.287,0,.355-.107.484-.473.527a12.861,12.861,0,0,0-4.589,1.4,13.66,13.66,0,0,0-7.4,10.305c-.124.743-.124.742-.884.728-.086,0-.172,0-.258,0-.732,0-1.464-.01-2.2,0-1.152.016-2.3.052-3.456.063-.2,0-.4-.015-.6-.031s-.4-.032-.6-.03c-1.041.009-2.082.049-3.124.055-.288,0-.357.118-.352.375.012.516.025,1.033,0,1.548-.021.369.095.487.474.483,1.992-.021,3.984-.016,5.977-.02h3.186c.086,0,.17.024.256.025a8.07,8.07,0,0,0,1.055-.005c.321-.037.452.056.486.373a10.793,10.793,0,0,0,.225,1.559,13.984,13.984,0,0,0,.647,1.91,13.6,13.6,0,0,0,11.1,8.635c.524.081.528.063.528.613q0,2.58,0,5.16,0,2.542,0,5.086c0,.586,0,.586.572.587.43,0,.859,0,1.29,0,.53,0,.531,0,.531-.52q0-5.2-.006-10.393c0-.35.1-.485.469-.532a13.8,13.8,0,0,0,12.015-11.859c.077-.571.083-.571.6-.571h.073c.876,0,1.75-.065,2.625-.062,1.251,0,2.5.062,3.751.063,1.373,0,2.745-.039,4.118-.056.2,0,.285-.088.283-.29-.006-.614.006-1.228-.015-1.842a.343.343,0,0,0-.223-.246c-.6-.042-1.2-.075-1.8-.073-1.047.006-2.1.049-3.142.054-.28,0-.559-.013-.839-.029s-.566-.03-.85-.028c-1.4.008-2.795.033-4.193.063-.247.005-.324-.08-.375-.324a20.3,20.3,0,0,0-.737-3.143,13.55,13.55,0,0,0-11.265-9.027c-.492-.077-.495-.06-.495-.569V21.469c0-1.683-.006-3.366,0-5.049,0-.293-.082-.42-.4-.409-.551.019-1.1.01-1.657,0h-.024c-.238,0-.327.1-.319.345",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -14.097,
    y1: 1.292,
    x2: -14.077,
    y2: 1.292,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009dcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3cacdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbd9a1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86310",
    "data-name": "Path 86310",
    d: "M734.1,36.982a4.184,4.184,0,0,0-4.224,4.2,4.073,4.073,0,0,0,4.19,4.111,4.157,4.157,0,1,0,.042-8.314H734.1",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -86.011,
    y1: 5.265,
    x2: -85.893,
    y2: 5.265,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_180047",
    "data-name": "Group 180047",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180042",
    "data-name": "Group 180042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180041",
    "data-name": "Group 180041",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86298",
    "data-name": "Path 86298",
    d: "M61.117.6,49.138.653l-1.86,11.069,6.359.023c18.491,0,18.537,15.235,16.383,27.444s-4.3,15.794-8.214,20.454a21.96,21.96,0,0,1-17.849,7.005H35.2L47.164.772H35.05l-3.5,22.053H21.426l-3.443,19.4H6.937L0,77.816H45.679q52.5,0,59.284-38.531Q111.719.561,61.117.6",
    fill: "#0085b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86299",
    "data-name": "Path 86299",
    d: "M138.178,58.52h28.6V78.76h-50.6v-77h50.05V21.78h-28.05v8.36h25.3v19.8h-25.3Z",
    fill: "#1c262a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86300",
    "data-name": "Path 86300",
    d: "M203.3,80.52q-12.54,0-20.9-5.225a25.48,25.48,0,0,1-11.22-14.134L189.988,50.27q3.85,9.792,13.861,9.79,7.478,0,7.479-3.96a3.664,3.664,0,0,0-.549-1.979,4.442,4.442,0,0,0-2.09-1.54c-1.029-.441-1.925-.788-2.695-1.045s-2.109-.642-4.015-1.156-3.338-.916-4.29-1.21Q174.7,42.24,174.7,24.42a22.588,22.588,0,0,1,7.645-17.49Q189.988,0,202.418,0a33.618,33.618,0,0,1,17.545,4.621A27.256,27.256,0,0,1,231.349,17.93L213.088,28.6q-3.19-8.139-10.559-8.14a6.966,6.966,0,0,0-4.345,1.156A3.546,3.546,0,0,0,196.7,24.53a4.086,4.086,0,0,0,2.584,3.74,63.8,63.8,0,0,0,9.955,3.41,91.962,91.962,0,0,1,9.021,3.135A40.4,40.4,0,0,1,225.629,39a16.842,16.842,0,0,1,5.775,6.929,23.9,23.9,0,0,1,1.924,9.955q0,11.772-8.084,18.2T203.3,80.52",
    fill: "#1c262a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6471",
    "data-name": "Rectangle 6471",
    width: 22,
    height: 77,
    transform: "translate(239.379 1.76)",
    fill: "#1c262a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86301",
    "data-name": "Path 86301",
    d: "M349.049,33.33v9.13q0,16.5-10.615,27.28T310.549,80.519q-18.042,0-29.48-11.495T269.629,40.37q0-17.16,11.44-28.766T309.668,0a40.894,40.894,0,0,1,19.746,4.84,37.173,37.173,0,0,1,14.135,13.09l-18.7,10.67q-4.62-7.04-14.74-7.041-8.25,0-13.365,5.281t-5.115,13.639a21.373,21.373,0,0,0,4.73,13.806q4.728,5.886,14.629,5.885,11.44,0,15.29-8.141H309.889V33.33Z",
    fill: "#1c262a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86302",
    "data-name": "Path 86302",
    d: "M399.1,1.76h22v77H403.5l-24.2-35.2v35.2h-22v-77h17.6l24.2,35.2Z",
    fill: "#1c262a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86303",
    "data-name": "Path 86303",
    d: "M480.719,57.42h25.63V78.76H451.9V61.819L476.428,23.1h-7.98V1.76h36.8V18.7Z",
    fill: "#1c262a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86304",
    "data-name": "Path 86304",
    d: "M462.321,23.095H451.557a3.95,3.95,0,0,1-3.95-3.951V5.711a3.95,3.95,0,0,1,3.95-3.951h10.764a3.951,3.951,0,0,1,3.951,3.951V19.144a3.951,3.951,0,0,1-3.951,3.951",
    fill: "#ff9b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86305",
    "data-name": "Path 86305",
    d: "M566.959,72.93q-8.691,7.591-22.66,7.59t-22.66-7.59q-8.691-7.59-8.69-19.91V1.76h22V50.6q0,8.58,9.35,8.58t9.349-8.58V1.76h22V53.02q0,12.321-8.689,19.91",
    fill: "#1c262a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86306",
    "data-name": "Path 86306",
    d: "M617.449,1.76q15.948,0,26.675,11.055T654.848,40.26q0,16.392-10.724,27.445T617.449,78.76h-31.9v-77Zm0,55.66A14.279,14.279,0,0,0,628.5,52.635q4.344-4.786,4.344-12.375T628.5,27.885A14.276,14.276,0,0,0,617.449,23.1h-8.8V57.42Z",
    fill: "#1c262a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6472",
    "data-name": "Rectangle 6472",
    width: 22,
    height: 77,
    transform: "translate(663.098 1.76)",
    fill: "#1c262a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86307",
    "data-name": "Path 86307",
    d: "M763.046,69.355q-11.826,11.605-28.985,11.6t-28.985-11.6Q693.25,57.751,693.251,40.7t11.825-28.656Q716.9.442,734.061.44t28.985,11.6Q774.869,23.653,774.871,40.7T763.046,69.355m-42.46-15.29A18.811,18.811,0,0,0,752.871,40.7a18.812,18.812,0,1,0-37.62,0,18.125,18.125,0,0,0,5.335,13.365",
    fill: "#1c262a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86308",
    "data-name": "Path 86308",
    d: "M763.982,40.7a29.922,29.922,0,1,1-29.921-29.921A29.921,29.921,0,0,1,763.982,40.7",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_180044",
    "data-name": "Group 180044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180043",
    "data-name": "Group 180043",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6474",
    "data-name": "Rectangle 6474",
    width: 50.287,
    height: 50.272,
    transform: "translate(708.911 16)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_180046",
    "data-name": "Group 180046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180045",
    "data-name": "Group 180045",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6475",
    "data-name": "Rectangle 6475",
    width: 8.485,
    height: 8.352,
    transform: "translate(729.805 36.982)",
    fill: "url(#linear-gradient-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.a3a05050d374f8a77343af2082bf7380.svg";
export { ForwardRef as ReactComponent };